import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
import { ClassifierDef, defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns, ClassifierData } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns, EntityColumns } from '@juvare/platform-shared/features/storage';

export const jobTitleEntityName = 'jobTitle';

export interface JobTitleData extends ClassifierData {
    description: string;
}

const jobTitleColumns = defineColumns({
    ...classifierColumns,
    description: {
        type: 'string',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});

export type JobTitleColumns = EntityColumns<typeof jobTitleColumns>;

type JobTitleDef = ClassifierDef<JobTitleData, JobTitleColumns>;

export function defineJobTitleClassifier(): JobTitleDef {
    return defineClassifierEntity<JobTitleData, JobTitleColumns>({
        entity: {
            version: 1,
            columns: jobTitleColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => ({
                ...transformClassifierColumns(params),
                description: params.data.description,
                search: [params.data.name, params.data.status].join(' '),
            }),
            onAnonymousAuthGet: (appState, response) => response,
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!requireAnySystemPermission(userState, 'manage-client-classifiers')) {
                    throw new AuthError('Unauthorized');
                }
            },
            audit: {
                columnForAuditIdReplacement: 'name',
            },
        },
    });
}
